<template>
    <div>
        <div v-if="loading"></div>
        <div v-else>
        <h1 class="page-title">
            <span v-if="!userHasActivePlan">Purchase Subscription</span>
            <span v-else>Update Subscription</span>
        </h1>
        <b-alert variant="success" show v-if="userHasActivePlan && !planIsCustom">You are currently on the {{subscription.websites_plan.name}} plan.</b-alert>
        <b-alert variant="info" show v-if="userHasActivePlan && planIsCustom">You are on a custom plan, please contact us to change your subscription.</b-alert>
        <p></p>
        <b-row>
            <demo-notice :show="!!$route.query.purchase" :initiatePurchase="$route.query.purchase"></demo-notice>
        </b-row>

            <b-row v-if="userHasActivePlan && !planIsCustom">
                <b-col>
                    <h4>More Options</h4>
                    <p><a :href="subscription.paddle_update_billing_url">Update Payment Method</a></p>
                    <div>
                        <b-button v-b-toggle.collapse-1 variant="secondary" size="sm">Cancel Subscription</b-button>
                        <b-collapse id="collapse-1" class="mt-2">
                            <b-card>
                                <b-alert variant="warning" show style="color:#856404;background-color:#fff3cd">Warning: This will stop your subscription and all recurring website audits, you will no longer have access to any historical data.<p>
                                </p></b-alert>
                                <b-button variant="danger" size="sm" :href="subscription.paddle_cancel_url">Cancel Subscription</b-button>
                            </b-card>
                        </b-collapse>

                    </div>
                    <p></p>
                </b-col>
            </b-row>
            <small>Our order process is conducted by our online reseller Paddle.com. Paddle.com is the Merchant of Record for all our orders. Paddle provides all customer service inquiries and handles returns.</small>
        </div>
    </div>
</template>

<script>
  import axios from "axios";
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  export default {
    name: 'Subscriptions',
    components: { Widget, DemoNotice },
    data(){
      return {
        completed: false,
        error: '',
        submitting: false,
        loading: true,
        userHasActivePlan: false,
        planIsCustom: false,
        agencyOptionsSelection: {name: 'agency',  price: '129',displayName: 'Agency'},
        agencyOptions: [
          { value: {name: 'agency',  price: '129', displayName: 'Agency'}, text: '2000 Audits', },
          { value: {name: 'agency_120',  price: '219', displayName: 'Agency (120)'}, text: '4000 Audits', },
          { value: {name: 'agency_250',  price: '429', displayName: 'Agency (250)'}, text: '9000 Audits' , },
        ],
        subscription: {},
        price:{
          free: {base: 0, pages: 50, devices: 4, maxAudit: 25},
          minimal: {base: 9, pages: 125, devices: 4, maxAudit: 25},
          startup: {base: 29, pages: 500, devices: 4, maxAudit: 100},
          business:  {base: 89, pages: 1500, devices: 4, maxAudit: 250},
          agency:  {base: 189, pages: 4000, devices: 4, maxAudit: 500},
        },
      }
    },
    apollo: {
      $subscribe: {
        websites_website: {
          query() {
            return gql`subscription {
                  websites_subscription {
                    state
                    paddle_cancel_url
                    paddle_update_billing_url
                    websites_plan{
                      name
                    }
                  }
          }`
          },
          skip () {
            return false;
          },
          result (data) {
            this.loading = true;

            this.subscription = data.data.websites_subscription[0];
            if (this.subscription) {
              this.userHasActivePlan = this.subscription.websites_plan.name !== 'free' && this.subscription.state === 'active';
              this.planIsCustom = ['free', 'startup', 'business', 'agency', 'agency_120', 'agency_250'].indexOf(this.subscription.websites_plan.name) === -1;
              if (this.subscription.websites_plan.name ===  'agency'){
                this.agencyOptionsSelection = this.agencyOptions[0].value;
              }
              if (this.subscription.websites_plan.name ===  'agency_120'){
                this.agencyOptionsSelection = this.agencyOptions[1].value;
              }
              if (this.subscription.websites_plan.name ===  'agency_250'){
                this.agencyOptionsSelection = this.agencyOptions[2].value;
              }
            }
            this.loading = false;
          },

        },

      }
    },
    computed: {
      priceAgency(){
        return '109';
      }
    },
    methods: {
      closeCallback(){
        this.submitting = false;
      },
      successCallback(){
        this.completed = true;
        this.submitting = false;
      },
      purchase(plan){
        this.submitting = true;
        this.error = '';

        axios
          .post(`payments/generate_paddle`, {
            plan: plan,
          })
          .then(
            response => {
              if (response.data.success) {
                if (response.data.show_form) {
                  window.Paddle.Checkout.open({
                    allowQuantity: false,
                    override: response.data.url,
                    closeCallback: this.closeCallback,
                    successCallback: this.successCallback,
                  });
                }
                else{
                  this.completed = true;
                }
              }
              else{
                this.$toast.show('Unable to process subscription, please try again later', 'Payment Error', this.toastOptions);
              }
              return true;
            },
            error => {
              this.submitting = false;
              if (error.response.data && error.response.data.message) {
                this.error = error.response.data.message;
              }
              else{
                this.error = 'There was an error processing your request, please try again.';
              }
            }
          );
      }
    },
    watch: {
      'activeSite': function () {
        this.dataLoaded = false;
      }
    },
    mounted() {
      this.submitting = false;
      this.$loadScript("https://cdn.paddle.com/paddle/paddle.js")
        .then(() => {
          // Script is loaded, do something
          window.Paddle.Setup({ vendor: 109078 });
        })
        .catch(() => {
        });
    },
  };
</script>

<style lang="scss">

</style>
